export enum SiteIdent {
  miniluDe = 'miniluDe',
  miniluAt = 'miniluAt',
  miniluNl = 'miniluNl',
  default = 'default',
}
